export function bytesToSize({
  bytes,
  to,
  isRound
}: {
  bytes: number;
  to?: number;
  isRound?: boolean;
}) {
  const sizesType = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Bytes';
  const i = parseInt(`${Math.floor(Math.log(bytes) / Math.log(1024))}`, 10);
  if (i === 0) return `${bytes} ${sizesType[i]})`;
  return `${
    isRound
      ? Math.ceil(bytes / 1024 ** i).toFixed(to === undefined ? 1 : to)
      : (bytes / 1024 ** i).toFixed(to === undefined ? 1 : to)
  } ${sizesType[i]}`;
}
